import classNames from 'classnames';
import { forwardRef } from 'react';
import styles from './VirtualScommesseWrapperInner.module.scss';

export type VirtualScommesseWrapperInnerProps = {
  children: React.ReactNode;
  isLeague?: boolean;
  className?: string;
};

const VirtualScommesseWrapperInner = forwardRef<HTMLDivElement, VirtualScommesseWrapperInnerProps>(
  ({ children, isLeague, className }, ref) => (
    <div ref={ref} className={classNames(styles.scommessa, className, { [styles.scommessaLeague]: isLeague })}>
      {children}
    </div>
  )
);

VirtualScommesseWrapperInner.displayName = 'VirtualScommesseWrapperInner';

export { VirtualScommesseWrapperInner };
